import { type FC } from "react";
import DropdownWithMultiSelect, {
  type MultiselectAccountValue,
} from "~/features/userAdministration/manageUsers/components/DropdownWithMultiselect/DropdownWithMultiSelect";
import { useTranslation } from "react-i18next";
import { styled } from "~/common/mui";

export enum EmailOrderQuoteDropdownType {
  ORDER,
  QUOTE,
}

interface EmailOrderQuoteAccountProp {
  list: MultiselectAccountValue[];
  selected: string;
  onChange?: (ids: string) => void;
  type: EmailOrderQuoteDropdownType;
}
export const EmailOrderQuoteAccount: FC<EmailOrderQuoteAccountProp> = ({ list, selected, onChange, type }) => {
  const { t } = useTranslation();
  return (
    <EmailOrderQuoteAccountSelector
      items={list}
      value={selected ? selected.split(",") : []}
      label={t("page.orderQuoteSettings.modal.label.account")}
      onChange={(e) => onChange?.((e.target.value as string[]).join(" "))}
      data-test-id={
        "email-order-quote-AccountMultiselect" +
        (type === EmailOrderQuoteDropdownType.ORDER ? "-order-account" : "-quote-account")
      }
    />
  );
};

const EmailOrderQuoteAccountSelector = styled(DropdownWithMultiSelect)(({ theme }) => ({
  zIndex: "auto",
  "& .scha__dropdown-multi-select__choose": {
    zIndex: 6,
  },
  "& .scha__dropdown-multi-select__value": {
    paddingRight: theme.spacing(2.5),
    "&__text": {
      display: "-webkit-box",
      fontSize: 13,
      maxHeight: 18,
      lineHeight: "18px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      wordBreak: "break-word",
      WebkitLineClamp: 1,
      WebkitBoxOrient: "vertical",
    },
  },
  "& label": {
    ...theme.typography.labelLarge,
    color: theme.palette.text.secondary,
  },
}));
